import React, { useState, useEffect } from 'react';
import './StepProgress.css';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation, useNavigate } from 'react-router-dom';
import CreateOrder from './CreateOrder';
import AddProductForm from './AddProduct';
import ViewOrder from '../Outbox/ViewOrderOutbox.js';
import { fetchOrderById, createOrder, addProduct, linkedOrder, editOrder, updateProduct, fetchLinkingOrders, resetOrderState, deleteOrderProduct, setOrder } from '../../../redux/orderSlice'; // Adjust imports based on actual file structure
import { ProductColumnDefDefaultFn } from '../columns/columnDef.js';
import MainTable from '../../../components/Table/PaginationTable';
import OrderStep from '../../../assets/images/ord-details.svg';
import ProductStep from '../../../assets/images/product.svg';
import Checkstep from '../../../assets/images/Check.svg';
import ConfirmOrder from './ConfirmOrder.js';
import LinkedOrdersModal from './Modals/LinkedOrderModal.js';
import OrderUpdatedSuccessfullyModal from '../../../components/Modals/OrderUpdatedSuccessfullyModal.js';


// export const icons = [OrderStep, ProductStep, Checkstep]
export const icons = [
  { icon: OrderStep, text: 'Order Details' },
  { icon: ProductStep, text: 'Add Product' },
  { icon: Checkstep, text: 'Confirm Order' }
];

const StepProgressOrder = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [actionType, setActionType] = useState('add'); // 'add', 'edit', 'view'
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [selectedOrderProductId, setSelectedOrderProductId] = useState(null);
  const [newOrderId, setOrderId] = useState(null); // State to store the orderId
  const [successModalopen, setSuccessModalOpen] = useState(false);
  const [productCount, setProductCount] = useState(0);
  const linkedOrderList = useSelector(state => state.order.linkingorders.data || []);
  const totalRecordsLink = useSelector(state => state.order.paginationInfoLinkingOrder?.totalRecords) || 0;
  const [pageNumber, setPageNumber] = useState(1); //  1-based indexing
  const [pageSize, setPageSize] = useState(12);
  const [modalOpen, setModalOpen] = useState(false);
  const updateOrder = useSelector(state => state.order.updateOrder || {})
  const orderDetails = useSelector((state) => state.order.orderDetails?.data || {});



  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation()

  const handleOrderSucessOpen = () => setSuccessModalOpen(true);
  const handleOrderSucessClose = () => setSuccessModalOpen(false);
  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);
  const productData = useSelector(state =>
    state.order.orderDetails && state.order.orderDetails.data && state.order.orderDetails.data.orderProducts
      ? state.order.orderDetails.data.orderProducts
      : []);
  useEffect(() => {
    // dispatch(resetOrderState())

    // console.log('$$$$$$$$$$$$', location)
    if (location.state && location.state.actionType) {
      setActionType(location.state.actionType);
      // const orderIdFromPathname = location.pathname.split('/').pop();
      setOrderId(location.state.orderId); // Set orderId
      console.log('location orderid:', location.state.orderId, actionType)

    }
  }, [location]);
  // oders detils
  useEffect(() => {
    // dispatch(resetOrderState())
    if (actionType === 'edit') {
    console.log("in else",newOrderId)

      dispatch(fetchOrderById(newOrderId));
      setProductCount(productData?.length)
    }
    //  else {
    //   console.log("in else")
    //   dispatch(fetchOrderById(newOrderId));
    // }

  }, [dispatch, actionType, newOrderId]);

  useEffect(() => {
    // dispatch(resetOrderState())

    const queryParams = {
      searchText: '',
      fromDate: '',
      toDate: '',
      pageSize, // Use state value
      pageNumber, // Use state value
    };
    dispatch(fetchLinkingOrders(queryParams));
  }, [dispatch, pageSize, pageNumber]);


  const navigateCallback = (orderId, actionType) => {
    // Determine the path based on actionType
    const path = actionType === 'edit' ? `/edit/${orderId}` : `/details/${orderId}`;
    navigate(path);
  };
  const editProductByIdFun = (orderProductId, productId, actionType) => {
    console.log("In Edit Product", orderProductId, actionType)
    setActionType(actionType);
    setCurrentStep(2);
    setSelectedOrderProductId(orderProductId)
    setSelectedProductId(productId)
    // navigate(`/edit-product/${productId}`, { state: { actionType: 'edit',productId:productId } });
  }
  const deleteProductByIdFun = (orderProductId, productId, actionType) => {
    console.log("In Delete Product", orderProductId, actionType)
    // setActionType(actionType);
    setCurrentStep(2);
    // dispatch(deleteOrderProduct({
    //   orderId: newOrderId,
    //   orderProductId: orderProductId,
    //   // updateProducts: productData
    // }));
    dispatch(deleteOrderProduct({
      orderId: newOrderId,
      orderProductId: orderProductId,
    })).then(() => {
      // This will be executed after the deleteOrderProduct action is successfully completed.
      console.log("Product deletion successful, fetching order details");
      dispatch(fetchOrderById(newOrderId));
    }).catch((error) => {
      // Handle any errors from the deletion process here.
      console.error("Failed to delete product", error);
    });
    setProductCount(productCount - 1);
  }
  const getOrderId = (orderDetails) => {
    if (Array.isArray(orderDetails) && orderDetails.length > 0) {
      return orderDetails[0].orderid; // Assuming the first item has the orderId
    }

    if (orderDetails && typeof orderDetails === 'object' && 'orderId' in orderDetails) {
      return orderDetails.orderId;
    }

    return null;
  };

  const productColumn = ProductColumnDefDefaultFn(navigateCallback, editProductByIdFun, deleteProductByIdFun);// editProductByIdFun, deleteOrderFun

  const handleNextStep = () => {
    setCurrentStep(currentStep + 1);
  };
  const handleStepChange = (stepNumber, action,productId) => {
      // if (currentStep === 2) {
      //   setActionType(action);
      // }
    if (stepNumber >= 1 && stepNumber <= 3) {
      setCurrentStep(stepNumber);
      setActionType(action);
      setSelectedProductId(productId); // For edit/view actions
    }
  };

  const handleCreateOrderSubmit = (data) => {
    // const editOrderID = data.orderId
    //  let updateActionType =  location.state.actionType
    console.log('Creating order with ::', actionType, newOrderId);
    if (actionType === 'add') {
      dispatch(createOrder(data))
        .then((actionResult) => {
          if (actionResult.type === 'order/createOrder/fulfilled') {
            console.log('Created Order',actionResult)
            dispatch(setOrder())
            setCurrentStep(2);
          } else {

            console.error('Order creation failed:', actionResult.payload);
          }
        })
        .catch((error) => {
          // Catch any errors that might have occurred during dispatch
          console.error('An unexpected error occurred:', error);
          // Here, you can handle unexpected errors, show error messages, etc.
        });
    } else {
      dispatch(editOrder({
        orderId: newOrderId,
        orderData: data
      })).then(() => {

        // debugger
        // setSuccessModalOpen(true);
        handleOrderSucessOpen()
        setCurrentStep(3)
        dispatch(fetchOrderById(newOrderId)).then(() => {
        });
      });

    }

  };
  const handleUpdateOrderSubmit = (data) => {
    console.log('Update order with ::', newOrderId, orderDetails.orderId);

    dispatch(editOrder({
      orderId: orderDetails.orderId,
      orderData: data
    })).then(() => {
      // debugger
      // setSuccessModalOpen(true);
      handleOrderSucessOpen()
      let path = `/details/${orderDetails.orderId}`
      navigate(path);
      console.log("My OrderId :", newOrderId)
      dispatch(fetchOrderById(orderDetails.orderId)).then(() => {
        // return <OrderUpdatedSuccessfullyModal/>
      });

    });
    console.log('Edit order with: 2', data);


  };

  const handleAddOrEditProductSubmit = (productData) => {
    console.log(`${actionType} product with:`, productData, orderDetails);
    const newOrderId = getOrderId(orderDetails);
    console.warn('Check newOrderID :', newOrderId)
    // Inside handleAddOrEditProductSubmit
    if (actionType === 'add') {
      console.log('Here you dispatch the addProduct action with the necessary productData');
      dispatch(addProduct({
        orderId: newOrderId,
        orderData: productData
      })).then(() => {
        dispatch(fetchOrderById(newOrderId)).then(() => {
        });
      });
      setProductCount(productCount + 1)
    } else {
      console.log('Dispatching the editProduct action with the necessary productData', currentStep);
      dispatch(updateProduct({
        orderId: newOrderId,
        orderProductId: selectedOrderProductId,
        updateProducts: productData
      }));
      setCurrentStep(3)
    }
    //  setCurrentStep(3)
  };

  const updateProgressBar = () => ((currentStep - 1) / 2) * 100;

  // This function is simplified for demonstration
  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return <div className="step step-1 mt-2">
          {/* <h3>Order Details</h3> */}
          <CreateOrder onSubmit={handleCreateOrderSubmit} initialValues={orderDetails} actionType={actionType} />
        </div>
      case 2:
        if (actionType === 'add' || actionType === 'edit') {
          return <div className="step step-2 mt-2">
            {/* <h3>Add Product</h3> */}
            <AddProductForm productId={selectedProductId} actionType={actionType} onSubmit={handleAddOrEditProductSubmit} initialValues={productData} currentStep={currentStep} handleStepChange={handleStepChange} handleNextStep={handleNextStep} orderProductId={selectedOrderProductId} productCount={productCount}
            />
            {(productCount !== 0)
              // || location?.state?.actionType === ACTION.EDIT 
              ?
              <>
                <div className='mt-5 ml-2'>
                  <h1 className="fprimary">Product Details</h1>
                </div>
                <MainTable
                  columns={productColumn}
                  data={productData}
                  enablePagination={false}
                  className='mt-5'
                />
              </> : null}
          </div>
        }
      // else {
      //   // Assuming ViewProduct is a component you've created for viewing product details
      //   return <div className="step step-3"><ViewProduct productId={selectedProductId} /></div>
      // }
      case 3:
        return <div className="step step-3 mt-2">
          {/* <h3>Confirm Order</h3> */}
          <ConfirmOrder
            currentStep={currentStep}
            actionType={actionType}
            handleStepChange={handleStepChange}
            handleNextStep={handleNextStep}
            onSubmit={handleUpdateOrderSubmit}
            editProductByIdFun={editProductByIdFun}
            linkedOrderList={linkedOrderList}
            deleteProductByIdFun={deleteProductByIdFun}
            totalRecordsLink={totalRecordsLink}
            successModalopen={successModalopen}
            handleOrderSucessOpen={handleOrderSucessOpen}
            handleOrderSucessClose={handleOrderSucessClose}
            productCount={productCount} />
        </div>
      default:
        return null;
    }
  };

  return (
    <>
      <div className="main-content">
        {/* Breadcrumb, progress bar, and other UI elements */}
        <nav aria-label="breadcrumb" className="bread-box">
          <div>
            <h1 className="fprimary">{actionType === 'edit' ? 'Edit Order' : 'Create Order'}</h1>
            <h5 className="">Add order and products details to {actionType === 'edit' ? 'edit ' : 'create a new'} order</h5>
          </div>
          <div>
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><a href="#">Home</a></li>
              <li className="breadcrumb-item"><a href="#">Order</a></li>
              <li className="breadcrumb-item active" aria-current="page">Create Order</li>
            </ol>
          </div>
        </nav>
        <div className="bad-box">
          <span className="badge bg-danger red-bages">Please note: Kindly fill in all details in English characters only and within character limits as specified below.</span>
        </div>
        <div className="card mt-3 bg-stage bg-dot">
          <div className="card-body">
            <div className="step-progress">
              <div className="progress px-1" style={{ height: '3px' }}>
                <div className="progress-bar" role="progressbar" style={{ width: `${updateProgressBar()}%` }} aria-valuenow={updateProgressBar()} aria-valuemin="0" aria-valuemax="100"></div>
              </div>
              <div className="step-container d-flex justify-content-between mb-5">
                {/* {icons.map((i, index) => (
                  <div key={index} className={`step-circle ${currentStep === index + 1 ? 'active' : ''}`} onClick={() => handleStepChange(index + 1)}><img src={i} /></div>
                ))} */}
                {icons.map((step, index) => (
                  <div key={index} className={`step-circle ${currentStep === index + 1 ? 'active' : ''}`} >
                    {/* onClick={() => handleStepChange(index + 1)} */}
                    <img src={step.icon} alt={`Step ${index + 1}`} />
                    <span className="step-text">{step.text}</span>
                  </div>
                ))}
              </div>
            </div>
            <div id="multi-step-form">
              {renderStepContent()}
            </div>
          </div>
        </div>
        {/* Navigation buttons and other components */}
      </div>
      <LinkedOrdersModal
        open={modalOpen}
        onClose={handleCloseModal}
        linkedOrderList={linkedOrderList}
        orderId={newOrderId}
        // orderDetails={orderDetails}
        // onLinkOrder={handleLinkOrder}
        // currentStep={currentStep}
        handleNextStep={handleNextStep}
      />

    </>
  );
};

export default StepProgressOrder;
